<template>
  <div id="projBidQuotedList">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" ref="searchInput" />
    </eb-header>
    <div class="order-box">
      <eb-order @getOrderData="getOrderData" :orderData="orderData" />
      <eb-type-filter
        class="screen"
        @getTypeFilterData="getTypeFilterData"
        :typeFilterData="typeFilterData"
      />
    </div>
    <div class="list-box">
      <div class="card-box" v-for="item in listData" :key="item.replyId">
        <eb-card-three>
          <ProjBidQuotedListCard @onDeleteQuote="onDeleteQuote" :project="item" />
        </eb-card-three>
      </div>
    </div>
    <eb-pagination
      :current-page.sync="pageNumber"
      v-if="paginationSize"
      @current-change="paginationData"
      :total="paginationSize"
    />
    <div
      v-if="(listRequestData.content||listRequestData.quoteStatus)&&!listData"
      class="noSearchText"
    >未搜索到结果</div>
    <div class="noodle" v-if="loadCount==1&&!listData">
      请点击招标商机
      <img :src="$ebConfig.imgPath+'img/noodle.png'" />
    </div>
    <NotarizationPayment></NotarizationPayment>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import ebOrder from '@/components/common/eb-order';
import ebTypeFilter from '@/components/common/eb-type-filter';
import ebCardThree from '@/components/common/card/eb-card-three';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import ProjBidQuotedListCard from '@/components/project/bid/list/ProjBidQuotedListCard';
import { myList } from '@/services/proj/bid-project-service';
import NotarizationPayment from '@/components/notarization/NotarizationPayment';
export default {
  name: 'projBidQuotedList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    ebOrder,
    ebTypeFilter,
    ebCardThree,
    ebPagination,
    ProjBidQuotedListCard,
    NotarizationPayment
  },
  data() {
    return {
      listData: null,
      paginationSize: null,
      orderData: {
        startTime: { text: '按发布时间', adesc: null },
        endTime: { text: '按截止时间', adesc: null }
      },
      typeFilterData: [
        { text: '全部', content: '' },
        { text: '草稿', content: '2' },
        { text: '已报价', content: 9 },
        { text: '已开标', content: 10 },
        { text: '公示中', content: 12 },
        { text: '已中选', content: 6 }
      ],
      listRequestData: {
        number: 10,
        page: 1,
        content: '',
        supplierUserId: this.$store.state.user.userInfo.userid,
        quoteStatus: '',
        orderAdesc: null
      },
      pageNumber: 1,
      loadCount: 0
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      let searchContent = sessionStorage.getItem('searchContent');
      if (searchContent !== null) {
        this.$refs.searchInput.text = searchContent;
        sessionStorage.removeItem('searchContent');
      }
    });
  },
  created() {
    this.initList();
  },
  methods: {
    async initList() {
      this.loadCount++;
      this.$root.layout.isLoading = true;
      try {
        let searchContent = sessionStorage.getItem('searchContent');
        if (searchContent !== null) {
          this.listRequestData.content = searchContent;
        }
        var params = this.listRequestData;
        if (!params.quoteStatus) {
          delete params.quoteStatus;
        }
        let { data } = await myList(params);
        if (data.returnCode === '01' || data.returnCode === '00') {
          this.listData = data.projectList;
          this.paginationSize = data.size;
        } else {
          this.$message.error('获取项目列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    // 初始化参数
    resetListRequestData() {
      this.listRequestData.page = 1;
      this.pageNumber = 1;
    },
    // 点击按照什么排序
    getOrderData: function(data) {
      this.resetListRequestData();
      this.listRequestData.orderAdesc = data;
      this.initList();
    },
    // 点击搜索
    searchData: function(data) {
      this.resetListRequestData();
      this.listRequestData.content = data;
      this.initList();
    },
    // 点击分页
    paginationData: function(data) {
      this.listRequestData.page = data;
      this.initList();
    },
    // 点击项目状态
    getTypeFilterData: function(data) {
      this.resetListRequestData();
      this.listRequestData.quoteStatus = data;
      this.initList();
    },
    // 删除项目重新加载项目
    onDeleteQuote: function() {
      this.initList();
    }
  }
};
</script>
<style scoped lang="less">
.order-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 49px 15px 36px;
}
.list-box {
}
.card-box {
  margin-bottom: 33px;
}
.noSearchText {
  font-size: 21px;
  margin-top: 20px;
  text-align: center;
}
.noodle {
  text-align: center;
  line-height: 200px;
  height: 200px;
  position: relative;
  font-size: 30px;
}
.noodle img {
  width: 500px;
  height: 199px;
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
  -o-transform: rotate(7deg); /* Opera */
  position: absolute;
  left: -64px;
  top: -44px;
}
</style>
